var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import config from '@/config';
import api from '@/shared/api';
import { useQuery } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { TaskQueryKey } from './queryKey';
export var useGetTaskAttachments = function (taskId, taskLevel, enabled) {
    var intl = useIntl();
    var retrieveAttachmentsForTaskIds = function (taskIds) {
        return api.base
            .post("".concat(config.appUrls.documents, "/api/documents/DocumentLinks"), taskIds)
            .then(function (res) { return res.data; });
    };
    var _a = useQuery([TaskQueryKey.TaskAttachments, taskId], function () {
        // if hovered over a main task, we'll retrieve the subtask IDs and check which documents are linked to them as well
        if (taskLevel === 0) {
            return api.base
                .get("".concat(config.appUrls.tasks, "/api/plannedtasks/ChildTaskIds/").concat(taskId))
                .then(function (_a) {
                var subtaskIds = _a.data;
                return retrieveAttachmentsForTaskIds(__spreadArray([taskId], subtaskIds, true));
            }, function () { return retrieveAttachmentsForTaskIds([taskId]); });
        }
        return retrieveAttachmentsForTaskIds([taskId]);
    }, {
        enabled: enabled,
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
        retry: false,
    }), data = _a.data, isLoading = _a.isLoading, error = _a.error, refetch = _a.refetch;
    return {
        data: data,
        error: error,
        isLoading: isLoading,
        refetch: refetch,
    };
};
